import axios from 'axios'
axios.defaults.withCredentials = true

const configJSON = { headers: { 'Content-Type': 'application/json' } }

class API {
  /**
   * Retourne une collection ou un objet
   * @param {string} path référence de la ressource
   * @param {Object} resource resource ou options à ajouter dans le body de la requête
   * @returns {object}
   */
  static get(path) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${path}`)
        .then(res => {
          const resource = res.data
          resolve(resource)
        })
        .catch(e => {
          reject(e)
        })
    })
  }

  /**
   * Création d'une ressource
   * @param {string} path référence de la ressource
   * @param {object} ressource ressource à créer
   * @returns {number}
   */
  static set(path, ressource) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${path}`, ressource, configJSON)
        .then(res => {
          const id = res.data.id
          resolve(id)
        })
        .catch(e => {
          reject(e)
        })
    })
  }

  /**
   * Modification d'une ressource
   * @param {string} path référence de la ressource
   * @param {object} ressource ressource à modifier
   */
  static update(path, ressource) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${path}`, ressource, configJSON)
        .then(() => {
          resolve()
        })
        .catch(e => {
          reject(e)
        })
    })
  }

  /**
   * Suppression d'une ressource
   * @param {string} path référence de la ressource
   */
  static delete(path) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${path}`)
        .then(() => {
          resolve()
        })
        .catch(e => {
          reject(e)
        })
    })
  }
}

export default API
